import { useEffect, useState } from 'react';
import { fetchMe, login as apiLogin, logout as apiLogout, type Me } from '../lib/api';
import LiveAdminPanel from '../components/admin/LiveAdminPanel';
import PhotoAdminPanel from '../components/admin/PhotoAdminPanel';
import TrackAdminPanel from '../components/admin/TrackAdminPanel';
import CalendarAdminPanel from '../components/admin/CalendarAdminPanel';
import '../styles/admin.css';

type Tab = 'live' | 'photos' | 'tracks' | 'calendar';

export default function BandAdmin() {
  const [me, setMe] = useState<Me | null>(null);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState<Tab>('calendar');

  useEffect(() => {
    fetchMe().then((m) => setMe(m)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="admin-shell"><p className="muted">Caricamento...</p></div>;
  if (!me?.authenticated) return <LoginScreen onLogin={(m) => setMe(m)} />;

  return (
    <div className="admin-shell">
      <header className="admin-header">
        <div className="admin-brand">GANG BAND · Pannello membri</div>
        <div className="admin-user">
          <a className="btn-ghost" href="/" title="Torna al sito">← Torna al sito</a>
          <a
            className="btn-ghost"
            href="https://drive.google.com/drive/u/2/folders/1eJ5dKq_hkUMbtBSX65ZhtW2BA6UjPsOy"
            target="_blank"
            rel="noopener noreferrer"
            title="Drive condiviso della band"
          >📁 Drive band</a>
          <span>{me.display_name}</span>
          <button
            className="btn-ghost"
            onClick={async () => {
              await apiLogout();
              setMe({ authenticated: false });
            }}
          >Esci</button>
        </div>
      </header>

      <nav className="admin-tabs">
        <button className={tab === 'calendar' ? 'is-active' : ''} onClick={() => setTab('calendar')}>📅 Calendario</button>
        <button className={tab === 'live' ? 'is-active' : ''} onClick={() => setTab('live')}>🎤 Date Live</button>
        <button className={tab === 'photos' ? 'is-active' : ''} onClick={() => setTab('photos')}>📷 Foto</button>
        <button className={tab === 'tracks' ? 'is-active' : ''} onClick={() => setTab('tracks')}>🎵 Tracce</button>
      </nav>

      <main className="admin-main">
        {tab === 'calendar' && <CalendarAdminPanel me={me} />}
        {tab === 'live' && <LiveAdminPanel />}
        {tab === 'photos' && <PhotoAdminPanel />}
        {tab === 'tracks' && <TrackAdminPanel />}
      </main>
    </div>
  );
}

function LoginScreen({ onLogin }: { onLogin: (m: Me) => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const me = await apiLogin(username, password);
      onLogin({ ...me, authenticated: true });
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Login fallito.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="admin-shell admin-login-wrap">
      <form className="admin-login" onSubmit={submit}>
        <h1>Accesso membri</h1>
        <p className="muted">Solo membri della band. Le credenziali sono quelle assegnate.</p>        <label>
          <span>Username</span>
          <input value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
        </label>
        <label>
          <span>Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <div className="admin-error">{error}</div>}
        <button type="submit" className="btn-primary" disabled={busy}>{busy ? '...' : 'Entra'}</button>
        <a href="/" className="btn-ghost" style={{ display: 'block', textAlign: 'center', marginTop: 12, textDecoration: 'none' }}>← Torna al sito</a>
      </form>
    </div>
  );
}
